/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DmsDownloadDto interface.
 */
export function instanceOfDmsDownloadDto(value) {
    if (!('mediaId' in value) || value['mediaId'] === undefined)
        return false;
    return true;
}
export function DmsDownloadDtoFromJSON(json) {
    return DmsDownloadDtoFromJSONTyped(json, false);
}
export function DmsDownloadDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mediaId': json['mediaId'],
    };
}
export function DmsDownloadDtoToJSON(json) {
    return DmsDownloadDtoToJSONTyped(json, false);
}
export function DmsDownloadDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'mediaId': value['mediaId'],
    };
}
